import React, { useEffect, useState } from "react";
import projectsData from "../../data/projects.json";
import "./Transition.css";

const Transition = ({ isAlbanian }) => {
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(0);
  const [animationDirection, setAnimationDirection] = useState("");
  const [projects, setProjects] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedDrop, setIsExpandedDrop] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    setProjects(projectsData);

    if (projectsData.length > 0) {
      setSelectedProjectIndex(0);
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setShowMore(window.innerWidth >= 2560);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleProjectChange = (newIndex) => {
    if (newIndex === selectedProjectIndex) return;

    setAnimationDirection("fade-out");

    setTimeout(() => {
      setSelectedProjectIndex(newIndex);
      setAnimationDirection("fade-in");
      setIsExpanded(false);
    }, 500);
  };

  const handleNext = () => {
    handleProjectChange((selectedProjectIndex + 1) % projects.length);
  };

  const handlePrevious = () => {
    handleProjectChange(
      (selectedProjectIndex - 1 + projects.length) % projects.length
    );
  };

  const truncateText = (text, maxLength) =>
    text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  return (
    <div className="transition-container">
      <div className="overlay">
        <div className="vertical-line left"></div>
        <div className="vertical-line right"></div>
        <div className="bottom-line"></div>
      </div>

      <div className="card-form">
        <div
          className={`red-card-select ${isExpanded ? "expanded" : "collapsed"}`}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="red-card-title-mobile">
            {isAlbanian
              ? projects[selectedProjectIndex]?.titulli_projekti
              : projects[selectedProjectIndex]?.project_title}
            <span className="red-card-arrow">{isExpanded ? "▲" : "▼"}</span>
          </div>

          {projects
            .slice(0, showMore || isMobile || isExpandedDrop ? 11 : 8)
            .map((project, index) => (
              <ul
                className={`red-card-title ${
                  selectedProjectIndex === index ? "active" : ""
                }`}
                key={project.projectId}
                onClick={() => handleProjectChange(index)}
              >
                <div className="red-card-number">
                  <li>{`${(index + 1).toString().padStart(2, "0")}`}</li>
                  <li className="red-card-project-title">
                    {isAlbanian
                      ? project.titulli_projekti
                      : project.project_title}
                  </li>
                </div>
              </ul>
            ))}

          {!showMore && !isMobile && (
            <ul className="red-card-title-arrow">
              <li onClick={() => setIsExpandedDrop(!isExpandedDrop)}>
                {isExpandedDrop ? (
                  <img src="/go-up.png" alt="Up" className="down-button" />
                ) : (
                  <img src="/down.png" alt="Down" className="down-button" />
                )}
              </li>
            </ul>
          )}
        </div>

        <div className={`projects-grid-card ${animationDirection}`}>
          {projects.length > 0 && (
            <div className="project-card">
              <div className="project-content">
                <button className="prev-btn" onClick={handlePrevious}>
                  <img src="/prev.png" alt="Prev" className="prev-btn-img" />
                </button>

                <h2 className="project-title">
                  {isAlbanian
                    ? projects[selectedProjectIndex].titulli_projekti
                    : projects[selectedProjectIndex].project_title}
                </h2>

                <div className="project-card-paragraph">
                  <p className="project-address">
                    {truncateText(
                      isAlbanian
                        ? projects[selectedProjectIndex].pershkrimi_projekti
                        : projects[selectedProjectIndex].project_description,
                      100
                    )}
                  </p>
                  <a
                    href={`/vilalproject/${projects[selectedProjectIndex].project_id}`}
                    rel="noopener noreferrer"
                  >
                    <p className="project-lookmore">
                      {isAlbanian ? "Shiko më shumë →" : "Look more →"}
                    </p>
                  </a>
                </div>
              </div>

              <div className="project-image-square">
                <a
                  href={`/vilalproject/${projects[selectedProjectIndex].project_id}`}
                  rel="noopener noreferrer"
                >
                  <img
                    src={projects[selectedProjectIndex].project_image_url}
                    alt={projects[selectedProjectIndex].project_title}
                    className="project-image"
                  />
                </a>
              </div>
              <button className="next-btn" onClick={handleNext}>
                <img src="/next.png" alt="Next" className="prev-btn-img" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Transition;
